( function( $ ) {
	var carouselsEles = document.querySelectorAll( '.carousel:not(.facility-image-gallery__carousel)' );
	if( !carouselsEles ) { return; }

	carouselsEles.forEach( ( carouselsEle ) => {
		$( carouselsEle ).carousel( { // Converting to JQuery to use bootstrap functionality
			interval: 4000,
			pause: 'hover',
			ride: 'carousel',
			wrap: true,
		} );

		carouselsEle.querySelector( '.carousel-play' ).addEventListener( 'click', function() {
			var carousel = this.closest( '.carousel' );
			$( carousel ).carousel( 'cycle' );
			carousel.querySelector( '.carousel-pause' ).classList.add( 'active' );
			carousel.querySelector( '.carousel-play' ).classList.remove( 'active' );
		} );

		carouselsEle.querySelector( '.carousel-pause' ).addEventListener( 'click', function() {
			var carousel = this.closest( '.carousel' );
			$( carousel ).carousel( 'pause' );
			carousel.querySelector( '.carousel-play' ).classList.add( 'active' );
			carousel.querySelector( '.carousel-pause' ).classList.remove( 'active' );
		} );
	} );
} )( jQuery );